import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { signout, switchSubject, changeSubject } from "../actions";
import Calculator from "./modals/Calculator.jsx";
import TimerN from "./TimerN";

const Topbar = (props) => {
  const [user, setUser] = useState(props.user);
  const [openCalculator, setOpenCalculator] = useState(false);

  useEffect(() => {
    setUser(props.user);
  }, []);

  const changeSubject = (subject) => {
    localStorage.setItem("currentSubject", JSON.stringify(subject));
    props.changeSubject({ ...props.user, currentSubject: subject });
  };

  const renderSubjects = () => {
    let currentSubject = props.user?.currentSubject;
    try {
      currentSubject = JSON.parse(localStorage.getItem("currentSubject")) || currentSubject;
    } catch (_) {
      // Use the candidate's subject if browser storage is unavailable or invalid.
    }
    let active;
    return user.subjects.map((subject) => {
      subject.integerCode === currentSubject?.integerCode ? (active = "disabled") : (active = "");
      return (
        <li key={subject.integerCode} className="nav-item no-arrow mx-1">
          <button type="button" onClick={() => changeSubject(subject)} className={`${active} btn btn-success btn-sm text-white d-flex align-items-center`}>
            {subject.name}
          </button>
        </li>
      );
    });
  };

  const toggle = () => {
    setOpenCalculator(false);
  };

  return (
    // <!-- Topbar -->
    <React.Fragment>
      {/* <CalculatorModal isOpen={openCalculator} toggle={toggle} /> */}
      <Calculator isOpen={openCalculator} toggle={toggle} />
      <nav className="navbar navbar-expand navbar-light bg-white topbar static-top shadow">
        {user.startedAt && (
          <ul className="navbar-nav">
            {renderSubjects()}
            <li className="nav-item no-arrow mx-1">
              <button
                onClick={() => {
                  setOpenCalculator(true);
                }}
                className="btn btn-sm btn-warning text-white d-flex align-items-center"
              >
                <i className="fas fa-calculator"></i>&nbsp;<small>Calculator</small>
              </button>
            </li>
          </ul>
        )}

        {/* <!-- Topbar Navbar --> */}
        <ul className="navbar-nav ml-auto">
          {/* <!-- Nav Item - Search Dropdown (Visible Only XS) --> */}
          <li className="nav-item dropdown no-arrow d-sm-none">
            <a className="nav-link dropdown-toggle" href="http://#" id="searchDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i className="fas fa-search fa-fw"></i>
            </a>
            {/* <!-- Dropdown - Messages --> */}
            <div className="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in" aria-labelledby="searchDropdown">
              <form className="form-inline mr-auto w-100 navbar-search">
                <div className="input-group">
                  <input type="text" className="form-control bg-light border-0 small" placeholder="Search for..." aria-label="Search" aria-describedby="basic-addon2" />
                  <div className="input-group-append">
                    <button className="btn btn-primary" type="button">
                      <i className="fas fa-search fa-sm"></i>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </li>

          {/* <!-- Nav Item - Alerts --> */}

          {/* <!-- Nav Item - Messages --> */}
          <li className="nav-item dropdown no-arrow mx-1">
            <TimerN
              durationInMinutes={user.durationInMinutes}
              timeSpentInSeconds={user.timeSpentInSeconds}
              examSuspendedAt={user.examSuspendedAt}
              totalAttempts={user.totalAttempted}
              candidateId={user.id}
            />
          </li>

          <div className="topbar-divider d-none d-sm-block"></div>

          {/* <!-- Nav Item - User Information --> */}
          <li className="nav-item dropdown no-arrow">
            <div className="nav-link" style={{ cursor: "default" }}>
              <span className="mr-2 d-none d-lg-inline text-gray-600 small">{props.user?.name}</span>
              <img className="img-profile rounded-circle" alt="profile" src="/img/undraw_profile.svg" />
            </div>
            <div className="row"></div>
            {/* <!-- Dropdown - User Information --> */}
            {/* <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
                        aria-labelledby="userDropdown">
                        <div className="dropdown-divider"></div>
                        <span className="dropdown-item" onClick={props.signout} data-toggle="modal" data-target="#logoutModal">
                            <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                            Logout
                        </span>
                    </div> */}
          </li>
        </ul>
      </nav>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return { user: state.auth.user.data };
};

export default connect(mapStateToProps, { signout, switchSubject, changeSubject })(Topbar);
